import { ChakraProvider } from "@chakra-ui/provider";
import LoadingProvider from "contexts/LoadingContext";
import { OfflineProvider } from "contexts/OfflineContext";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/lib/integration/react";
import store, { persistor } from "redux/store";
import reportWebVitals from "./reportWebVitals";
import theme from "./theme";
import App from "./App";
import "./assets/styles/index.scss";
import { initPeripheralConnection } from "libs/peripheral/type";
import AppLayoutProvider from "providers/AppLayoutProvider";
import ErrorBoundary from "components/ErrorBoundary";
import CacheProvider from "libs/cache-project/CacheProvider";

initPeripheralConnection();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

export function render(root: ReactDOM.Root, app: React.ReactNode) {
  root.render(
    <ErrorBoundary>
      <Provider store={store}>
        <PersistGate loading={<div />} persistor={persistor}>
          <LoadingProvider>
            <BrowserRouter basename={process.env.PUBLIC_URL}>
              <ChakraProvider resetCSS theme={theme}>
                <AppLayoutProvider>
                  <OfflineProvider>
                    <CacheProvider>{app}</CacheProvider>
                  </OfflineProvider>
                </AppLayoutProvider>
              </ChakraProvider>
            </BrowserRouter>
          </LoadingProvider>
        </PersistGate>
      </Provider>
    </ErrorBoundary>
  );
}

render(root, <App />);

reportWebVitals();
